import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewComponent } from './view/view.component';
import { TranslationDataService } from '@src/app/core/services/translation-data.service';

const routes: Routes = [
  {
    path : "",
    pathMatch :'full',
    component : ViewComponent,
    data: {
      languageFilePath: "assets/i18n/account/"
    },
    resolve: { TranslationDataService } 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
